import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Timeline,
  Button,
  Tag,
  Input,
  DatePicker, Select,      // ADD
  Checkbox,
} from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  ThunderboltOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  BankOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import { ServicetypeService } from "../../../Services/Manage/ServicetypeService";  // ADD

const { Text } = Typography;
const quillModules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};


const stripHtml = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const ViewLine = ({ label, value }) => (
  <div
    style={{
      marginBottom: 10,
      paddingBottom: 8,
      borderBottom: "1px solid #f0f0f0",
    }}
  >
    <div
      style={{
        color: "#8c8c8c",
        fontSize: 12,
        fontWeight: 500,
        marginBottom: 2,
      }}
    >
      {label}
    </div>

    <div
      style={{
        color: "#262626",
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.6,
        wordBreak: "break-word",
      }}
    >
      {value || "-"}
    </div>
  </div>
);

const EditInput = ({ label, value, onChange, textarea }) => (
  <div style={{ marginBottom: 8 }}>
    <Text
      style={{
        color: "#6b7280",
        fontSize: 11,
        fontWeight: 500,
      }}
    >
      {label}
    </Text>

    {textarea ? (
      <Input.TextArea
        rows={2}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          marginTop: 2,
          fontSize: 13,
        }}
      />
    ) : (
      <Input
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          marginTop: 2,
          fontSize: 13,
        }}
      />
    )}
  </div>
);

const ListEqData = ({
  data = {},
  setEqData,
  mode = "create",
  enquirySelected = false,
}) => {
  const [editCustomer, setEditCustomer] = useState(false);
  const [editRequirement, setEditRequirement] = useState(false);

  const [customerInfo, setCustomerInfo] = useState({});
  const [requirementInfo, setRequirementInfo] = useState({});

  const [allServices, setAllServices] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [optionService, setOptionService] = useState([]);
  const [optionProducts, setOptionProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const isExistingEnquiry = !!data?.eq_id;

  const hasCustomerData =
    data?.name ||
    data?.company_name ||
    data?.mobile_no ||
    data?.contact_phone ||
    data?.contact_whatsapp ||
    data?.email ||
    data?.contact_email ||
    data?.gstin ||
    data?.address ||
    data?.location_city;

  const hasRequirementData =
    data?.eq_description ||
    data?.summary ||
    data?.industry_type ||
    data?.business_type ||
    data?.no_of_users ||
    data?.number_of_employees ||
    data?.expected_start_date ||
    data?.expected_go_live ||
    data?.note;

  useEffect(() => {
  // Existing enquiry selected
  if (data?.eq_id) {
    setEditCustomer(false);
    setEditRequirement(false);
    return;
  }

  // New quotation without enquiry
  if (mode === "create" && !enquirySelected) {
    setEditCustomer(true);
    setEditRequirement(true);
    return;
  }

  setEditCustomer(false);
  setEditRequirement(false);
}, [data?.eq_id, mode, enquirySelected]);

  useEffect(() => {
    setCustomerInfo({
      name: data?.name || "",
      company_name: data?.company_name || "",
      mobile_no:
        data?.contact_whatsapp ||
        data?.mobile_no ||
        data?.contact_phone ||
        "",
      email:
        data?.contact_email ||
        data?.email ||
        data?.email_id ||
        "",
      gstin: data?.gstin || "",
      address:
        data?.location_city ||
        data?.address ||
        "",
    });

    const parseItems = (items) => {
      if (Array.isArray(items)) return items;
      try { return JSON.parse(items || "[]"); } catch { return []; }
    };
    const svcRows = parseItems(data?.service_items);
    const prdRows = parseItems(data?.product_items);
    const itemNames = [
      ...svcRows.map((i) => i.service_name || i.name),
      ...prdRows.map((i) => i.product_name || i.name),  
    ].filter(Boolean);

    const builtHtml = itemNames.length
      ? "<ul>" + itemNames.map((n) => `<li>${n}</li>`).join("") + "</ul>"
      : "";

    setRequirementInfo({
      requirement:
        data?.eq_description ||
        data?.summary ||
        builtHtml ||
        "",
      business_type:
        data?.industry_type ||
        data?.business_type ||
        "",
      no_of_users:
        data?.number_of_employees ||
        data?.no_of_users ||
        data?.users_count ||
        "",
      expected_start_date:
        data?.expected_go_live ||
        data?.expected_start_date ||
        "",
      remarks:
        data?.note ||
        "",
    });
  }, [data]);

  // ADD ↓
  useEffect(() => {
    const loadServices = async () => {
      try {
        const req = await ServicetypeService.getAllServices();
        const active = (req.data || []).filter((i) => i.status === "Active");
        setAllServices(active);
        setOptionService(active.map((i) => ({ value: i.id, label: i.service_name })));
      } catch (e) { console.error(e); }
    };
    const loadProducts = async () => {
      try {
        const req = await ServicetypeService.getAllProducts();
        const active = (req.data || []).filter((i) => i.status === "Active");
        setAllProducts(active);
        setOptionProducts(active.map((i) => ({ value: i.id, label: i.name })));
      } catch (e) { console.error(e); }
    };
    loadServices();
    loadProducts();
  }, []);

  useEffect(() => {
    const parse = (items) => {
      if (Array.isArray(items)) return items;
      try { return JSON.parse(items || "[]"); } catch { return []; }
    };
    setSelectedServices(parse(data?.service_items));
    setSelectedProducts(parse(data?.product_items));
  }, [data?.service_items, data?.product_items]);
  // ADD ↑

  const parseItems = (items) => {
    if (Array.isArray(items)) return items;
    try {
      return JSON.parse(items || "[]");
    } catch {
      return [];
    }
  };

  const serviceRows = parseItems(data?.service_items);
  const productRows = parseItems(data?.product_items);

  const requirements = [
    ...serviceRows.map((item) => item.service_name || item.name),
    ...productRows.map((item) => item.product_name || item.name),
  ].filter(Boolean);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const saveCustomer = async () => {
    setEqData?.((prev) => ({
      ...prev,
      name: customerInfo.name,
      company_name: customerInfo.company_name,
      mobile_no: customerInfo.mobile_no,
      contact_phone: customerInfo.mobile_no,
      contact_whatsapp: customerInfo.mobile_no,
      email: customerInfo.email,
      contact_email: customerInfo.email,
      gstin: customerInfo.gstin,
      address: customerInfo.address,
      location_city: customerInfo.address,
    }));

    setEditCustomer(false);
  };


  const saveRequirement = async () => {
    setEqData?.((prev) => ({
      ...prev,
      eq_description: requirementInfo.requirement,
      summary: requirementInfo.requirement,
      industry_type: requirementInfo.business_type,
      business_type: requirementInfo.business_type,
      no_of_users: requirementInfo.no_of_users,
      number_of_employees: requirementInfo.no_of_users,
      expected_go_live_date: requirementInfo.expected_start_date,
      expected_start_date: requirementInfo.expected_start_date,
      note: requirementInfo.remarks,
    }));

    setEditRequirement(false);
  };

  const syncServices = (next) => {
    setSelectedServices(next);
    setEqData?.((p) => ({ ...p, service_items: next }));
  };
  const syncProducts = (next) => {
    setSelectedProducts(next);
    setEqData?.((p) => ({ ...p, product_items: next }));
  };



  //activity timeline 
  const timelineItems = [];
  const textStyle = { fontSize: 11 };

// CREATED
timelineItems.push({
  color: "green",
  children: (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <Typography.Text strong style={textStyle}>
          Quotation Created
        </Typography.Text>
        <br />
        <Typography.Text type="secondary">
          {data?.prepared_by || data?.added_by || "-"}
        </Typography.Text>
      </div>

      <Typography.Text type="secondary">
        {data?.date
          ? dayjs(data.date).format("DD MMM YYYY hh:mm A")
          : "-"}
      </Typography.Text>
    </div>
  ),
});

// SENT
if (
  ["Sent", "Viewed", "Negotiation", "Approved", "Converted"].includes(
    data?.quotation_status
  )
) {
  timelineItems.push({
    color: "purple",
    children: (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Typography.Text strong style={textStyle}>
            Quotation Sent To Customer
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">
            {data?.prepared_by || "-"}
          </Typography.Text>
        </div>

        <Typography.Text type="secondary">
          {data?.updated_on
            ? dayjs(data.updated_on).format(
                "DD MMM YYYY hh:mm A"
              )
            : "-"}
        </Typography.Text>
      </div>
    ),
  });
}

// VIEWED
if (
  ["Viewed", "Negotiation", "Approved", "Converted"].includes(
    data?.quotation_status
  )
) {
  timelineItems.push({
    color: "gold",
    children: (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Typography.Text strong style={textStyle}>
            Customer Viewed Quotation
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">
            {data?.customer_name || "Customer"}
          </Typography.Text>
        </div>

        <Typography.Text type="secondary">
          {data?.updated_on
            ? dayjs(data.updated_on).format(
                "DD MMM YYYY hh:mm A"
              )
            : "-"}
        </Typography.Text>
      </div>
    ),
  });
}

// NEGOTIATION
if (
  ["Negotiation", "Approved", "Converted"].includes(
    data?.quotation_status
  )
) {
  timelineItems.push({
    color: "orange",
    children: (
      <>
        <Typography.Text strong style={textStyle}>
          Negotiation Started
        </Typography.Text>
      </>
    ),
  });
}

// APPROVED
if (
  ["Approved", "Converted"].includes(
    data?.quotation_status
  )
) {
  timelineItems.push({
    color: "green",
    children: (
      <>
        <Typography.Text strong style={textStyle}>
          Quotation Approved
        </Typography.Text>
      </>
    ),
  });
}

// CONVERTED
if (data?.quotation_status === "Converted") {
  timelineItems.push({
    color: "blue",
    children: (
      <>
        <Typography.Text strong style={textStyle}>
          Converted To Project
        </Typography.Text>
      </>
    ),
  });
}

// REVISED
if (Number(data?.revision_no || 1) > 1) {
  timelineItems.push({
    color: "cyan",
    children: (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Typography.Text strong style={textStyle}>
            Revised Quotation #{data?.revision_no}
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">
            {data?.prepared_by || "-"}
          </Typography.Text>
        </div>

        <Typography.Text type="secondary">
          {data?.updated_on
            ? dayjs(data.updated_on).format(
                "DD MMM YYYY hh:mm A"
              )
            : "-"}
        </Typography.Text>
      </div>
    ),
  });
}




  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={8}>
        <Card
          title={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(11, 93, 148, 0.95)",
                }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                }}
              >
                <UserOutlined style={{ color: "rgba(11, 93, 148, 0.95)", marginRight: 8 }} />
                Customer Information
              </span>

              {editCustomer ? (
                <span>
                  <Button type="link" size="small" onClick={saveCustomer}>
                    Save
                  </Button>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => setEditCustomer(false)}
                  >
                    Cancel
                  </Button>
                </span>
              ) : (
                <Button
                  type="link"
                  size="small"
                  onClick={() => setEditCustomer(true)}
                >
                  Edit
                </Button>
              )}
            </div>
          }
          style={{ borderRadius: 12 }}
          headStyle={{
            minHeight: 42,
            padding: "0 12px",
          }}
          bodyStyle={{
            padding: "10px 12px",
          }}
        >
          {editCustomer ? (
            <>
              <EditInput
                label="Customer Name"
                value={customerInfo.name}
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, name: v }));
                  setEqData?.((p) => ({ ...p, name: v }));
                }}
              />

              <EditInput
                label="Company Name"
                value={customerInfo.company_name}
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, company_name: v }));
                  setEqData?.((p) => ({ ...p, company_name: v }));
                }}
              />

              <EditInput
                label="Mobile Number"
                value={customerInfo.mobile_no}
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, mobile_no: v }));
                  setEqData?.((p) => ({
                    ...p,
                    mobile_no: v,
                    contact_phone: v,
                    contact_whatsapp: v,
                  }));
                }}
              />

              <EditInput
                label="Email Address"
                value={customerInfo.email}
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, email: v }));
                  setEqData?.((p) => ({
                    ...p,
                    email: v,
                    contact_email: v,
                  }));
                }}
              />

              <EditInput
                label="GSTIN"
                value={customerInfo.gstin}
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, gstin: v }));
                  setEqData?.((p) => ({ ...p, gstin: v }));
                }}
              />

              <EditInput
                label="Address"
                value={customerInfo.address}
                textarea
                onChange={(v) => {
                  setCustomerInfo((p) => ({ ...p, address: v }));
                  setEqData?.((p) => ({
                    ...p,
                    address: v,
                    location_city: v,
                  }));
                }}
              />
            </>
          ) : (
            <>
              <ViewLine
                label="Customer Name"
                value={customerInfo.name}
              />

              <ViewLine
                label="Company Name"
                value={customerInfo.company_name}
              />

              <ViewLine
                label="Mobile Number"
                value={customerInfo.mobile_no}
              />

              <ViewLine
                label="Email Address"
                value={customerInfo.email}
              />

              <ViewLine label="GSTIN" value={customerInfo.gstin} />

              <ViewLine
                label="Address"
                value={customerInfo.address}
              />
            </>
          )}
        </Card>
      </Col>

      <Col xs={24} lg={8}>
        <Card
          title={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(11, 93, 148, 0.95)",
                }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                }}
              >
                <FileTextOutlined
                  style={{ color: "rgba(11, 93, 148, 0.95)", marginRight: 8 }}
                />
                Requirement Summary
              </span>

              {editRequirement ? (
                <span>
                  <Button type="link" size="small" onClick={saveRequirement}>
                    Save
                  </Button>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => setEditRequirement(false)}
                  >
                    Cancel
                  </Button>
                </span>
              ) : (
                <Button
                  type="link"
                  size="small"
                  onClick={() => setEditRequirement(true)}
                >
                  Edit
                </Button>
              )}
            </div>
          }
          style={{ borderRadius: 12 }}
          headStyle={{
            minHeight: 42,
            padding: "0 12px",
          }}
          bodyStyle={{
            padding: "10px 12px",
          }}
        >
          {editRequirement ? (
            <>
<div style={{ marginBottom: 12 }}>
                <Text
                  style={{
                    color: "#6b7280",
                    fontSize: 11,
                    fontWeight: 500,
                    display: "block",
                    marginBottom: 4,
                  }}
                >
                  Requirement
                </Text>

                <Row gutter={8}>
                  <Col span={12}>
                    <Select
                      mode="multiple"
                      options={optionService}
                      size="small"
                      showSearch
                      allowClear
                      placeholder="Add Service"
                      style={{ width: "100%" }}
                      value={selectedServices.map((s) => s.service_id)}
                      tagRender={() => null}
                      maxTagCount={0}
                      onChange={(ids) => {
                        const next = ids.map((id) => {
                          const existing = selectedServices.find(
                            (s) => Number(s.service_id) === Number(id)
                          );
                          if (existing) return existing;
                          const svc = allServices.find(
                            (x) => Number(x.id) === Number(id)
                          );
                          return {
                            service_id: svc.id,
                            service_name: svc.service_name,
                            unit_price: Number(svc.unit_price || 0),
                            unit: svc.unit || "",
                            hsn_code: "",
                          };
                        });
                        syncServices(next);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Col>

                  <Col span={12}>
                    <Select
                      mode="multiple"
                      options={optionProducts}
                      size="small"
                      showSearch
                      allowClear
                      placeholder="Add Product"
                      style={{ width: "100%" }}
                      value={selectedProducts.map((p) => p.product_id)}
                      tagRender={() => null}
                      maxTagCount={0}
                      onChange={(ids) => {
                        const next = ids.map((id) => {
                          const existing = selectedProducts.find(
                            (p) => Number(p.product_id) === Number(id)
                          );
                          if (existing) return existing;
                          const prod = allProducts.find(
                            (x) => Number(x.id) === Number(id)
                          );
                          return {
                            product_id: prod.id,
                            product_name: prod.name,
                            unit_price: Number(prod.unit_price || 0),
                            unit: prod.unit || "",
                            hsn_code:
                              prod.hsn_code || prod.sku || prod.code_name || "",
                          };
                        });
                        syncProducts(next);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Col>
                </Row>

{(selectedServices.length > 0 || selectedProducts.length > 0) && (
                  <Row gutter={12} style={{ marginTop: 10 }}>
                    <Col span={12}>
                      {selectedServices.length > 0 && (
                        <>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", marginBottom: 2 }}>
                            Services
                          </div>
                          <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                            {selectedServices.map((item, index) => (
                              <li key={`svc-${index}`}>{item.service_name}</li>
                            ))}
                          </ul>
                        </>
                      )}
                    </Col>
                    <Col span={12}>
                      {selectedProducts.length > 0 && (
                        <>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", marginBottom: 2 }}>
                            Products
                          </div>
                          <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                            {selectedProducts.map((item, index) => (
                              <li key={`prd-${index}`}>{item.product_name}</li>
                            ))}
                          </ul>
                        </>
                      )}
                    </Col>
                  </Row>
                )}
              </div>

              <EditInput
                label="Business Type"
                value={requirementInfo.business_type}
                onChange={(v) => {
                  setRequirementInfo((p) => ({ ...p, business_type: v }));
                  setEqData?.((p) => ({
                    ...p,
                    industry_type: v,
                    business_type: v,
                  }));
                }}
              />

              <EditInput
                label="No. of Users"
                value={requirementInfo.no_of_users}
                onChange={(v) => {
                  setRequirementInfo((p) => ({ ...p, no_of_users: v }));
                  setEqData?.((p) => ({
                    ...p,
                    no_of_users: v,
                    number_of_employees: v,
                  }));
                }}
              />

              <div style={{ marginBottom: 14 }}>
                <Text
                  style={{
                    color: "#6b7280",
                    fontSize: 11,
                    fontWeight: 500,
                  }}
                >
                  Expected Launch / Start Date
                </Text>

                <DatePicker
                  size="small"
                  style={{
                    width: "100%",
                    marginTop: 2,
                  }}
                  value={
                    requirementInfo.expected_start_date
                      ? dayjs(requirementInfo.expected_start_date)
                      : null
                  }
                  onChange={(v) => {
                    const dateValue = v ? dayjs(v).format("YYYY-MM-DD") : "";

                    setRequirementInfo((p) => ({
                      ...p,
                      expected_start_date: dateValue,
                    }));

                    setEqData?.((p) => ({
                      ...p,
                      expected_start_date: dateValue,
                      expected_go_live_date: dateValue,
                    }));
                  }}
                />
              </div>

              <EditInput
                label="Remarks from Enquiry"
                value={requirementInfo.remarks}
                textarea
                onChange={(v) => {
                  setRequirementInfo((p) => ({ ...p, remarks: v }));
                  setEqData?.((p) => ({ ...p, note: v }));
                }}
              />
            </>
          ) : (
            <>
    <ViewLine
                label="Requirement"
                value={
                  serviceRows.length || productRows.length ? (
                    <Row gutter={12}>
                      <Col span={12}>
                        {serviceRows.length > 0 && (
                          <>
                            <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", marginBottom: 2 }}>
                              Services
                            </div>
                            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                              {serviceRows.map((item, index) => (
                                <li key={`svc-${index}`}>{item.service_name || item.name}</li>
                              ))}
                            </ul>
                          </>
                        )}
                      </Col>
                      <Col span={12}>
                        {productRows.length > 0 && (
                          <>
                            <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", marginBottom: 2 }}>
                              Products
                            </div>
                            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                              {productRows.map((item, index) => (
                                <li key={`prd-${index}`}>{item.product_name || item.name}</li>
                              ))}
                            </ul>
                          </>
                        )}
                      </Col>
                    </Row>
                  ) : requirementInfo.requirement ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: requirementInfo.requirement }}
                      style={{ lineHeight: 1.6 }}
                    />
                  ) : null
                }
              />

              <ViewLine
                label="Business Type"
                value={requirementInfo.business_type}
              />

              <ViewLine
                label="No. of Users"
                value={requirementInfo.no_of_users}
              />

              <ViewLine
                label="Expected Launch / Start Date"
                value={formatDate(requirementInfo.expected_start_date)}
              />

              <ViewLine
                label="Remarks from Enquiry"
                value={requirementInfo.remarks}
              />
            </>
          )}
        </Card>
      </Col>

      <Col xs={24} lg={8}>
        <Card
          title={
            <span
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "rgba(11, 93, 148, 0.95)",
              }}
            >
              <ThunderboltOutlined style={{ color: "rgba(11, 93, 148, 0.95)", marginRight: 8 }} />
              Activity Timeline
            </span>
          }
          style={{ borderRadius: 12 }}
          headStyle={{
            minHeight: 42,
            padding: "0 12px",
          }}
          bodyStyle={{
            padding: "10px 12px",
          }}
        >
   <Timeline items={timelineItems} />

<div style={{ textAlign: "center", marginTop: 20 }}>
  <Button
    size="small"
    style={{
      borderRadius: 8,
      fontWeight: 500,
    }}
  >
    View All Activities
  </Button>
</div>

          
        </Card>
      </Col>
    </Row>
  );
};

export default ListEqData;

<style>{`
.requirement-editor .ql-toolbar {
  padding: 4px !important;
}

.requirement-editor .ql-editor {
  min-height: 120px !important;
  font-size: 13px !important;
}
 .requirement-editor .ql-editor {
  direction: ltr !important;
  text-align: left !important;
}
`}</style>